import store from '../store'
import qs from 'qs'
import {
  APPID
} from '@/data/config.js'
export default function (next) {
  const loginState = store.state.loginState
  console.log('登录啦:::', loginState)
  if (loginState === 0) {
    // 需要授权
    console.log('需要授权')
    // 微信未授权登录跳转到授权登录页面
    const url = location.href
    // 解决重复登录url添加重复的code与state问题
    const urlArr = url.split('?')
    const parseUrl = qs.parse(urlArr[1])
    let loginUrl
    if (parseUrl.code && parseUrl.state) {
      delete parseUrl.code
      delete parseUrl.state
      loginUrl = `${urlArr[0]}?${qs.stringify(parseUrl)}`
    } else {
      loginUrl = url
    }
    loginUrl = encodeURIComponent(loginUrl)
    // 设置微信授权回调地址
    const wechatAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${loginUrl}&response_type=code&scope=snsapi_base&state=leqi#wechat_redirect`
    // 跳转到微信授权页面
    store.commit('setLoginState', 1)
    window.location.href = wechatAuthUrl
  } else if (loginState === 1) {
    // 授权中
    console.log('授权中...')
    const nowurl = location.href
    console.log('nowurl:::', nowurl)
    const nowurlParse = qs.parse(nowurl.split('?')[1])
    console.log('nowurlParse:::', nowurlParse)
    const code = nowurlParse.code
    if (!code) {
      store.commit('setLoginState', 0)
      location.reload()
    }
    store.dispatch('getLoginA', code).then(() => {
      next()
    })
  } else {
    // 已经登陆
    next()
  }
}
